import script from "./fw29_css_selectors.vue?vue&type=script&setup=true&lang=js"
export * from "./fw29_css_selectors.vue?vue&type=script&setup=true&lang=js"

import "./fw29_css_selectors.vue?vue&type=style&index=0&id=03fa1ace&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03fa1ace"]])

export default __exports__